export const enum RetrievalMode {
    Hybrid = "hybrid",
    Vectors = "vectors",
    Text = "text"
}

export const enum GPT4VInput {
    TextAndImages = "textAndImages",
    Images = "images",
    Texts = "texts"
}

export const enum VectorFieldOptions {
    Embedding = "embedding",
    ImageEmbedding = "imageEmbedding",
    Both = "both"
}

export type ChatAppRequestOverrides = {
    retrieval_mode?: RetrievalMode;
    semantic_ranker?: boolean;
    semantic_captions?: boolean;
    exclude_category?: string;
    top?: number;
    temperature?: number;
    minimum_search_score?: number;
    minimum_reranker_score?: number;
    prompt_template?: string;
    prompt_template_prefix?: string;
    prompt_template_suffix?: string;
    suggest_followup_questions?: boolean;
    use_oid_security_filter?: boolean;
    use_groups_security_filter?: boolean;
    use_gpt4v?: boolean;
    gpt4v_input?: GPT4VInput;
    vector_fields: VectorFieldOptions[];
};

export type ResponseMessage = {
    content: string;
    role: string;
};

export type Thoughts = {
    title: string;
    description: any; // It can be any output from the api
    props?: { [key: string]: string };
};

export type ResponseContext = {
    data_points: string[];
    followup_questions: string[] | null;
    thoughts: Thoughts[];
};

export type ResponseChoice = {
    index: number;
    message: ResponseMessage;
    context: ResponseContext;
    session_state: any;
};

export type ChatAppResponseOrError = {
    choices?: ResponseChoice[];
    error?: string;
    session_state: string;
};

export type ChatAppResponse = {
    choices: ResponseChoice[];
};

export type ChatAppRequestContext = {
    overrides?: ChatAppRequestOverrides;
};

export type ChatAppRequest = {
    messages: ResponseMessage[];
    // context?: ChatAppRequestContext;
    // stream?: boolean;
    session_state?: any;
    chat_id?: string;
    conversation_style?: string;
    file?: string | ArrayBuffer | null;
    fileName?: string;
    fileType?: string;
};

export type BotAppResponse = {
    message: string;
    session_state: string;
    followup_questions: string[] | null;
    isHistory?: boolean;
};

export type StreamingChunk = {
    type: "content_delta" | "tool_call" | "final_response" | "error" | "stream_end" | "thinking";
    content?: string;
    full_content?: string;
    tool_name?: string;
    followup_questions?: string[];
};

export type Config = {
    showGPT4VOptions: boolean;
    showSemanticRankerOption: boolean;
    showVectorOption: boolean;
    showUserUpload: boolean;
    showChatHistoryBrowser: boolean;
    showChatHistoryPostgres: boolean;
};

export type SimpleAPIResponse = {
    message?: string;
};

export type HistoryListApiResponse = {
    sessions: {
        id: string;
        entra_oid: string;
        title: string;
        timestamp: number;
        conversation_type?: string;
    }[];
    continuation_token?: string;
};
export type HistoryApiResponse = {
    id: string;
    entra_oid: string;
    answers: any;
};
